import { bindable } from "aurelia";


export class E5Dropdown {

    @bindable id = "";
    @bindable displayCloseButton = false;
    @bindable isSmall = false;

    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    
    constructor() { }

    toggle() {
        let el = document.querySelector('#' + this.id);
        el && this.setFilterVisible(!el.open);
    }

    setFilterVisible(show) {
        if (show) {
            document.querySelector('#' + this.id).show();
        } else {
            document.querySelector('#' + this.id).close();
        }
    }

    close() {
        this.setFilterVisible(false);
        return true;
    }

    stopEventAllowDefault(e) {
        e.stopPropagation();
        return true;
    }
}